export default "__VITE_ASSET__X9PrKFwM__"